import { useMemo } from 'react';
import useSWR from 'swr';
import { StructsBillingRateResponse } from 'types/__generated__/SimInventoryApi';
import getFetcher from 'api/utils/getFetcher';
import { ApiBaseError } from '../utils/shared';

export interface BillingRatesResultError extends ApiBaseError {}

const useBillingRates = (orgId?: OrgId) => {
  const url = orgId
    ? `${process.env.VITE_BIZ_API_ROOT}/sim-inventory/billing/rates?orgId=${orgId}`
    : null;

  const { data, error, isLoading, isValidating, mutate } = useSWR<
    StructsBillingRateResponse,
    BillingRatesResultError
  >(url, getFetcher);

  const billingRates = useMemo(() => data ?? {}, [data]);

  return {
    billingRates,
    error,
    isLoading,
    isValidating,
    mutate,
  };
};

export default useBillingRates;
